import { useSettings } from "@/context/SettingsContext";
import { MessageCircle } from "lucide-react";

export function SupportPill() {
  const { settings } = useSettings();
  return (
    <a href={settings?.support_url || "#"} target="_blank" rel="noreferrer"
      className="fixed top-20 right-4 z-30 md:hidden inline-flex items-center gap-2 bg-white text-[#1f222d] font-bold text-sm px-4 py-2.5 rounded-full shadow-lg hover:scale-105 transition-transform"
      data-testid="support-pill">
      <MessageCircle size={16} className="text-green-600" /> Destek
    </a>
  );
}
